import LabeledSection from "../../UI/LabeledSection";
import labels from "../../../utils/labels";
import { useAppSelector } from "../../../store/hooks";

const AddressSettings = () => {
  const address = useAppSelector(
    (state) => state.calendarSettingsSlice.calendarSettingsData?.address,
  );
  const startAddress = address?.startAddress;
  const endAddress = address?.endAddress;

  return (
    <LabeledSection
      spacing="big"
      classes="flex-1"
      title={labels.addressSettings}
    >
      <div className="flex gap-8">
        <LabeledSection
          spacing="small"
          title={labels.startAddress}
          classes="!gap-[var(--spacing-sm)]"
          titleSize="h4"
        >
          {startAddress ?? (
            <span className="text-[var(--col-text-secondary)]">
              {labels.noAddress}
            </span>
          )}
        </LabeledSection>

        <LabeledSection
          spacing="small"
          title={labels.endAddress}
          classes="!gap-[var(--spacing-sm)]"
          titleSize="h4"
        >
          {endAddress ?? (
            <span className="text-[var(--col-text-secondary)]">
              {labels.noAddress}
            </span>
          )}
        </LabeledSection>
      </div>
    </LabeledSection>
  );
};

export default AddressSettings;
